import { SEND_EMAIL_FORM } from "../../../../constants/modal.constant";
import React, { useCallback } from "react";
import { useEmailCore } from "../../../../cores/email";
import { useGlobalCore } from "../../../../cores/globals";
import { useMeCore } from "../../../../cores/me";
import { useTemplateCore } from "../../../../cores/templates";
import { addSign } from "../../../utils/signUtils";
import SendEmailForm from "../../gmail/modals/SendEmailForm";
import { buildContactFromEmail } from "./customFieldActions";

export function useOpenCustomFieldEmail(cardId: string | null = null) {
  const { turnOnModal } = useGlobalCore();
  const { company, getMeSigns, setSign } = useMeCore();
  const { setMessage } = useEmailCore();
  const { getEmailTemplates } = useTemplateCore();

  return useCallback(
    async (email: string) => {
      const trimmed = email.trim();
      if (!trimmed) return;

      const meSigns = await getMeSigns();
      const defaultSign = meSigns ? meSigns.find((sign) => sign.default) : null;

      if (defaultSign) {
        setSign(defaultSign);
        setMessage(addSign("<p><br></p>", defaultSign));
      } else {
        setSign(null);
        setMessage("");
      }

      getEmailTemplates(company?.id!);
      turnOnModal(
        SEND_EMAIL_FORM,
        <SendEmailForm
          contacts={[buildContactFromEmail(trimmed)]}
          cardId={cardId}
        />
      );
    },
    [
      turnOnModal,
      getMeSigns,
      setSign,
      setMessage,
      getEmailTemplates,
      company,
      cardId,
    ]
  );
}
